import { render, staticRenderFns } from "./ContentReceiver.vue?vue&type=template&id=51bf28a7&scoped=true"
import script from "./ContentReceiver.vue?vue&type=script&lang=js"
export * from "./ContentReceiver.vue?vue&type=script&lang=js"
import style0 from "./ContentReceiver.vue?vue&type=style&index=0&id=51bf28a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_webpack@5.108.4__lodash@4.18.1_prettier@3.9.5_vue-t_1661a82514c85892bee2ee9ef8290494/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf28a7",
  null
  
)

export default component.exports